import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";
export function useRepositoryConnectionModal() {
    return useOctopusFeatureToggle("github-repository-connection-modal", false);
}
